module.exports = __webpack_public_path__ + "static/img/top2_1.a35add2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/Main/top2_1.jpg
// module id = 1156
// module chunks = 18